// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/camera_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata2 } from "../google/protobuf/empty";
import { protoMetadata as protoMetadata1, Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "camerabot";

export enum FrameType {
  UNKNOWN = 0,
  COLOR = 1,
  DEPTH = 2,
  STEREO = 3,
  UNRECOGNIZED = -1,
}

export function frameTypeFromJSON(object: any): FrameType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return FrameType.UNKNOWN;
    case 1:
    case "COLOR":
      return FrameType.COLOR;
    case 2:
    case "DEPTH":
      return FrameType.DEPTH;
    case 3:
    case "STEREO":
      return FrameType.STEREO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FrameType.UNRECOGNIZED;
  }
}

export function frameTypeToJSON(object: FrameType): string {
  switch (object) {
    case FrameType.UNKNOWN:
      return "UNKNOWN";
    case FrameType.COLOR:
      return "COLOR";
    case FrameType.DEPTH:
      return "DEPTH";
    case FrameType.STEREO:
      return "STEREO";
    case FrameType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CameraType {
  UNKNOWN_CAMERA = 0,
  REALSENSE = 1,
  LUXONIS = 2,
  STATIC_VIDEO = 3,
  GIGE = 4,
  UNRECOGNIZED = -1,
}

export function cameraTypeFromJSON(object: any): CameraType {
  switch (object) {
    case 0:
    case "UNKNOWN_CAMERA":
      return CameraType.UNKNOWN_CAMERA;
    case 1:
    case "REALSENSE":
      return CameraType.REALSENSE;
    case 2:
    case "LUXONIS":
      return CameraType.LUXONIS;
    case 3:
    case "STATIC_VIDEO":
      return CameraType.STATIC_VIDEO;
    case 4:
    case "GIGE":
      return CameraType.GIGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CameraType.UNRECOGNIZED;
  }
}

export function cameraTypeToJSON(object: CameraType): string {
  switch (object) {
    case CameraType.UNKNOWN_CAMERA:
      return "UNKNOWN_CAMERA";
    case CameraType.REALSENSE:
      return "REALSENSE";
    case CameraType.LUXONIS:
      return "LUXONIS";
    case CameraType.STATIC_VIDEO:
      return "STATIC_VIDEO";
    case CameraType.GIGE:
      return "GIGE";
    case CameraType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ConnectionType {
  UNKNOWN_CONNECTION = 0,
  ETHERNET = 1,
  USB = 2,
  UNRECOGNIZED = -1,
}

export function connectionTypeFromJSON(object: any): ConnectionType {
  switch (object) {
    case 0:
    case "UNKNOWN_CONNECTION":
      return ConnectionType.UNKNOWN_CONNECTION;
    case 1:
    case "ETHERNET":
      return ConnectionType.ETHERNET;
    case 2:
    case "USB":
      return ConnectionType.USB;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConnectionType.UNRECOGNIZED;
  }
}

export function connectionTypeToJSON(object: ConnectionType): string {
  switch (object) {
    case ConnectionType.UNKNOWN_CONNECTION:
      return "UNKNOWN_CONNECTION";
    case ConnectionType.ETHERNET:
      return "ETHERNET";
    case ConnectionType.USB:
      return "USB";
    case ConnectionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CameraStatus {
  DISCONNECTED = 0,
  BUSY = 1,
  CONNECTING = 2,
  CONNECTED = 3,
  UNRECOGNIZED = -1,
}

export function cameraStatusFromJSON(object: any): CameraStatus {
  switch (object) {
    case 0:
    case "DISCONNECTED":
      return CameraStatus.DISCONNECTED;
    case 1:
    case "BUSY":
      return CameraStatus.BUSY;
    case 2:
    case "CONNECTING":
      return CameraStatus.CONNECTING;
    case 3:
    case "CONNECTED":
      return CameraStatus.CONNECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CameraStatus.UNRECOGNIZED;
  }
}

export function cameraStatusToJSON(object: CameraStatus): string {
  switch (object) {
    case CameraStatus.DISCONNECTED:
      return "DISCONNECTED";
    case CameraStatus.BUSY:
      return "BUSY";
    case CameraStatus.CONNECTING:
      return "CONNECTING";
    case CameraStatus.CONNECTED:
      return "CONNECTED";
    case CameraStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** TODO Refine these */
export enum ErrorCode {
  UNKNOWN_ERROR = 0,
  NOT_FOUND = 1,
  UNRECOGNIZED = -1,
}

export function errorCodeFromJSON(object: any): ErrorCode {
  switch (object) {
    case 0:
    case "UNKNOWN_ERROR":
      return ErrorCode.UNKNOWN_ERROR;
    case 1:
    case "NOT_FOUND":
      return ErrorCode.NOT_FOUND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCode.UNRECOGNIZED;
  }
}

export function errorCodeToJSON(object: ErrorCode): string {
  switch (object) {
    case ErrorCode.UNKNOWN_ERROR:
      return "UNKNOWN_ERROR";
    case ErrorCode.NOT_FOUND:
      return "NOT_FOUND";
    case ErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ConfigValueType {
  UNKNOWN_VALUE = 0,
  INT_VALUE = 1,
  FLOAT_VALUE = 2,
  STRING_VALUE = 3,
  BOOL_VALUE = 4,
  UNRECOGNIZED = -1,
}

export function configValueTypeFromJSON(object: any): ConfigValueType {
  switch (object) {
    case 0:
    case "UNKNOWN_VALUE":
      return ConfigValueType.UNKNOWN_VALUE;
    case 1:
    case "INT_VALUE":
      return ConfigValueType.INT_VALUE;
    case 2:
    case "FLOAT_VALUE":
      return ConfigValueType.FLOAT_VALUE;
    case 3:
    case "STRING_VALUE":
      return ConfigValueType.STRING_VALUE;
    case 4:
    case "BOOL_VALUE":
      return ConfigValueType.BOOL_VALUE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConfigValueType.UNRECOGNIZED;
  }
}

export function configValueTypeToJSON(object: ConfigValueType): string {
  switch (object) {
    case ConfigValueType.UNKNOWN_VALUE:
      return "UNKNOWN_VALUE";
    case ConfigValueType.INT_VALUE:
      return "INT_VALUE";
    case ConfigValueType.FLOAT_VALUE:
      return "FLOAT_VALUE";
    case ConfigValueType.STRING_VALUE:
      return "STRING_VALUE";
    case ConfigValueType.BOOL_VALUE:
      return "BOOL_VALUE";
    case ConfigValueType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StereoPosition {
  LEFT = 0,
  RIGHT = 1,
  UNRECOGNIZED = -1,
}

export function stereoPositionFromJSON(object: any): StereoPosition {
  switch (object) {
    case 0:
    case "LEFT":
      return StereoPosition.LEFT;
    case 1:
    case "RIGHT":
      return StereoPosition.RIGHT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StereoPosition.UNRECOGNIZED;
  }
}

export function stereoPositionToJSON(object: StereoPosition): string {
  switch (object) {
    case StereoPosition.LEFT:
      return "LEFT";
    case StereoPosition.RIGHT:
      return "RIGHT";
    case StereoPosition.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Nothing {
}

export interface CameraId {
  value: string;
}

export interface GetFrameRequest {
  cameraId: string;
  streamName?: string | undefined;
}

export interface CameraTrack {
  name: string;
  frameType: FrameType;
  cameraId: string;
}

export interface ConfigValue {
  intValue?: number | undefined;
  floatValue?: number | undefined;
  stringValue?: string | undefined;
  boolValue?: boolean | undefined;
}

/** Represents a single configuration option */
export interface ConfigOption {
  displayName: string;
  description: string;
  canEdit: boolean;
  configValue: ConfigValue | undefined;
  type: ConfigValueType;
  requiresRestart: boolean;
  priority?: number | undefined;
  minValue?: number | undefined;
  maxValue?: number | undefined;
}

/** A complete camera configuration composed of many config options */
export interface CameraConfiguration {
  configOptions: { [key: string]: ConfigOption };
}

export interface CameraConfiguration_ConfigOptionsEntry {
  key: string;
  value: ConfigOption | undefined;
}

export interface CameraConfigurationValueMap {
  configValues: { [key: string]: ConfigValue };
}

export interface CameraConfigurationValueMap_ConfigValuesEntry {
  key: string;
  value: ConfigValue | undefined;
}

export interface CameraFrame {
  cameraId: string;
  timestamp: Date | undefined;
  data: Uint8Array;
}

export interface StereoConfiguration {
  position: StereoPosition;
  linkedCamera: string;
}

export interface StreamInfo {
  key: string;
  frameType: FrameType;
}

export interface CameraDevice {
  id: string;
  name: string;
  label: string;
  type: CameraType;
  modelName: string;
  enabled: boolean;
  ipAddress?: string | undefined;
  config: CameraConfiguration | undefined;
  status: CameraStatus;
  latencyAvg?: number | undefined;
  enableStereo: boolean;
  stereoConfig?: StereoConfiguration | undefined;
  availableStreams: StreamInfo[];
  /** Most recent error message from camera */
  lastError?: string | undefined;
}

export interface CameraMetadata {
  id: string;
  metadataJson: string;
}

export interface CameraDeviceList {
  cameras: CameraDevice[];
}

export interface DeviceConfiguration {
  id: string;
  name: string;
  config: CameraConfigurationValueMap | undefined;
  enableStereo: boolean;
  stereoConfig?: StereoConfiguration | undefined;
}

/** Error information */
export interface Error {
  code: ErrorCode;
  message: string;
}

export interface CameraDeviceListResult {
  data?: CameraDeviceList | undefined;
  error?: Error | undefined;
}

export interface CameraDeviceResult {
  data?: CameraDevice | undefined;
  error?: Error | undefined;
}

export interface CameraMetadataResult {
  data?: CameraMetadata | undefined;
  error?: Error | undefined;
}

export interface CameraFrameResult {
  data?: CameraFrame | undefined;
  error?: Error | undefined;
}

export interface CameraIntrinsics {
  width: number;
  height: number;
  fx: number;
  fy: number;
  ppx: number;
  ppy: number;
  distortionCoefficients: number[];
  distortionModel?: string | undefined;
}

export interface GetCameraIntrinsicsRequest {
  cameraId: string;
  frameType: FrameType;
}

export interface CameraIntrinsicsResult {
  data?: CameraIntrinsics | undefined;
  error?: Error | undefined;
}

function createBaseNothing(): Nothing {
  return {};
}

export const Nothing: MessageFns<Nothing> = {
  encode(_: Nothing, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Nothing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNothing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Nothing {
    return {};
  },

  toJSON(_: Nothing): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Nothing>, I>>(base?: I): Nothing {
    return Nothing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Nothing>, I>>(_: I): Nothing {
    const message = createBaseNothing();
    return message;
  },
};

function createBaseCameraId(): CameraId {
  return { value: "" };
}

export const CameraId: MessageFns<CameraId> = {
  encode(message: CameraId, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraId {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraId {
    return { value: isSet(object.value) ? globalThis.String(object.value) : "" };
  },

  toJSON(message: CameraId): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraId>, I>>(base?: I): CameraId {
    return CameraId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraId>, I>>(object: I): CameraId {
    const message = createBaseCameraId();
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseGetFrameRequest(): GetFrameRequest {
  return { cameraId: "", streamName: undefined };
}

export const GetFrameRequest: MessageFns<GetFrameRequest> = {
  encode(message: GetFrameRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cameraId !== "") {
      writer.uint32(10).string(message.cameraId);
    }
    if (message.streamName !== undefined) {
      writer.uint32(18).string(message.streamName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFrameRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFrameRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cameraId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.streamName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFrameRequest {
    return {
      cameraId: isSet(object.cameraId) ? globalThis.String(object.cameraId) : "",
      streamName: isSet(object.streamName) ? globalThis.String(object.streamName) : undefined,
    };
  },

  toJSON(message: GetFrameRequest): unknown {
    const obj: any = {};
    if (message.cameraId !== "") {
      obj.cameraId = message.cameraId;
    }
    if (message.streamName !== undefined) {
      obj.streamName = message.streamName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFrameRequest>, I>>(base?: I): GetFrameRequest {
    return GetFrameRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFrameRequest>, I>>(object: I): GetFrameRequest {
    const message = createBaseGetFrameRequest();
    message.cameraId = object.cameraId ?? "";
    message.streamName = object.streamName ?? undefined;
    return message;
  },
};

function createBaseCameraTrack(): CameraTrack {
  return { name: "", frameType: 0, cameraId: "" };
}

export const CameraTrack: MessageFns<CameraTrack> = {
  encode(message: CameraTrack, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.frameType !== 0) {
      writer.uint32(16).int32(message.frameType);
    }
    if (message.cameraId !== "") {
      writer.uint32(26).string(message.cameraId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraTrack {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraTrack();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.frameType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cameraId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraTrack {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      frameType: isSet(object.frameType) ? frameTypeFromJSON(object.frameType) : 0,
      cameraId: isSet(object.cameraId) ? globalThis.String(object.cameraId) : "",
    };
  },

  toJSON(message: CameraTrack): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.frameType !== 0) {
      obj.frameType = frameTypeToJSON(message.frameType);
    }
    if (message.cameraId !== "") {
      obj.cameraId = message.cameraId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraTrack>, I>>(base?: I): CameraTrack {
    return CameraTrack.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraTrack>, I>>(object: I): CameraTrack {
    const message = createBaseCameraTrack();
    message.name = object.name ?? "";
    message.frameType = object.frameType ?? 0;
    message.cameraId = object.cameraId ?? "";
    return message;
  },
};

function createBaseConfigValue(): ConfigValue {
  return { intValue: undefined, floatValue: undefined, stringValue: undefined, boolValue: undefined };
}

export const ConfigValue: MessageFns<ConfigValue> = {
  encode(message: ConfigValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intValue !== undefined) {
      writer.uint32(16).int32(message.intValue);
    }
    if (message.floatValue !== undefined) {
      writer.uint32(29).float(message.floatValue);
    }
    if (message.stringValue !== undefined) {
      writer.uint32(34).string(message.stringValue);
    }
    if (message.boolValue !== undefined) {
      writer.uint32(40).bool(message.boolValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.intValue = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.floatValue = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stringValue = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.boolValue = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigValue {
    return {
      intValue: isSet(object.intValue) ? globalThis.Number(object.intValue) : undefined,
      floatValue: isSet(object.floatValue) ? globalThis.Number(object.floatValue) : undefined,
      stringValue: isSet(object.stringValue) ? globalThis.String(object.stringValue) : undefined,
      boolValue: isSet(object.boolValue) ? globalThis.Boolean(object.boolValue) : undefined,
    };
  },

  toJSON(message: ConfigValue): unknown {
    const obj: any = {};
    if (message.intValue !== undefined) {
      obj.intValue = Math.round(message.intValue);
    }
    if (message.floatValue !== undefined) {
      obj.floatValue = message.floatValue;
    }
    if (message.stringValue !== undefined) {
      obj.stringValue = message.stringValue;
    }
    if (message.boolValue !== undefined) {
      obj.boolValue = message.boolValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigValue>, I>>(base?: I): ConfigValue {
    return ConfigValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigValue>, I>>(object: I): ConfigValue {
    const message = createBaseConfigValue();
    message.intValue = object.intValue ?? undefined;
    message.floatValue = object.floatValue ?? undefined;
    message.stringValue = object.stringValue ?? undefined;
    message.boolValue = object.boolValue ?? undefined;
    return message;
  },
};

function createBaseConfigOption(): ConfigOption {
  return {
    displayName: "",
    description: "",
    canEdit: false,
    configValue: undefined,
    type: 0,
    requiresRestart: false,
    priority: undefined,
    minValue: undefined,
    maxValue: undefined,
  };
}

export const ConfigOption: MessageFns<ConfigOption> = {
  encode(message: ConfigOption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.displayName !== "") {
      writer.uint32(10).string(message.displayName);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.canEdit !== false) {
      writer.uint32(24).bool(message.canEdit);
    }
    if (message.configValue !== undefined) {
      ConfigValue.encode(message.configValue, writer.uint32(34).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(40).int32(message.type);
    }
    if (message.requiresRestart !== false) {
      writer.uint32(48).bool(message.requiresRestart);
    }
    if (message.priority !== undefined) {
      writer.uint32(56).uint32(message.priority);
    }
    if (message.minValue !== undefined) {
      writer.uint32(69).float(message.minValue);
    }
    if (message.maxValue !== undefined) {
      writer.uint32(77).float(message.maxValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigOption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.canEdit = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.configValue = ConfigValue.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.requiresRestart = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.priority = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.minValue = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.maxValue = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigOption {
    return {
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      canEdit: isSet(object.canEdit) ? globalThis.Boolean(object.canEdit) : false,
      configValue: isSet(object.configValue) ? ConfigValue.fromJSON(object.configValue) : undefined,
      type: isSet(object.type) ? configValueTypeFromJSON(object.type) : 0,
      requiresRestart: isSet(object.requiresRestart) ? globalThis.Boolean(object.requiresRestart) : false,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : undefined,
      minValue: isSet(object.minValue) ? globalThis.Number(object.minValue) : undefined,
      maxValue: isSet(object.maxValue) ? globalThis.Number(object.maxValue) : undefined,
    };
  },

  toJSON(message: ConfigOption): unknown {
    const obj: any = {};
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.canEdit !== false) {
      obj.canEdit = message.canEdit;
    }
    if (message.configValue !== undefined) {
      obj.configValue = ConfigValue.toJSON(message.configValue);
    }
    if (message.type !== 0) {
      obj.type = configValueTypeToJSON(message.type);
    }
    if (message.requiresRestart !== false) {
      obj.requiresRestart = message.requiresRestart;
    }
    if (message.priority !== undefined) {
      obj.priority = Math.round(message.priority);
    }
    if (message.minValue !== undefined) {
      obj.minValue = message.minValue;
    }
    if (message.maxValue !== undefined) {
      obj.maxValue = message.maxValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigOption>, I>>(base?: I): ConfigOption {
    return ConfigOption.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigOption>, I>>(object: I): ConfigOption {
    const message = createBaseConfigOption();
    message.displayName = object.displayName ?? "";
    message.description = object.description ?? "";
    message.canEdit = object.canEdit ?? false;
    message.configValue = (object.configValue !== undefined && object.configValue !== null)
      ? ConfigValue.fromPartial(object.configValue)
      : undefined;
    message.type = object.type ?? 0;
    message.requiresRestart = object.requiresRestart ?? false;
    message.priority = object.priority ?? undefined;
    message.minValue = object.minValue ?? undefined;
    message.maxValue = object.maxValue ?? undefined;
    return message;
  },
};

function createBaseCameraConfiguration(): CameraConfiguration {
  return { configOptions: {} };
}

export const CameraConfiguration: MessageFns<CameraConfiguration> = {
  encode(message: CameraConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.configOptions).forEach(([key, value]) => {
      CameraConfiguration_ConfigOptionsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = CameraConfiguration_ConfigOptionsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.configOptions[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraConfiguration {
    return {
      configOptions: isObject(object.configOptions)
        ? Object.entries(object.configOptions).reduce<{ [key: string]: ConfigOption }>((acc, [key, value]) => {
          acc[key] = ConfigOption.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: CameraConfiguration): unknown {
    const obj: any = {};
    if (message.configOptions) {
      const entries = Object.entries(message.configOptions);
      if (entries.length > 0) {
        obj.configOptions = {};
        entries.forEach(([k, v]) => {
          obj.configOptions[k] = ConfigOption.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraConfiguration>, I>>(base?: I): CameraConfiguration {
    return CameraConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraConfiguration>, I>>(object: I): CameraConfiguration {
    const message = createBaseCameraConfiguration();
    message.configOptions = Object.entries(object.configOptions ?? {}).reduce<{ [key: string]: ConfigOption }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = ConfigOption.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseCameraConfiguration_ConfigOptionsEntry(): CameraConfiguration_ConfigOptionsEntry {
  return { key: "", value: undefined };
}

export const CameraConfiguration_ConfigOptionsEntry: MessageFns<CameraConfiguration_ConfigOptionsEntry> = {
  encode(message: CameraConfiguration_ConfigOptionsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      ConfigOption.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraConfiguration_ConfigOptionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraConfiguration_ConfigOptionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = ConfigOption.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraConfiguration_ConfigOptionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? ConfigOption.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: CameraConfiguration_ConfigOptionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = ConfigOption.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraConfiguration_ConfigOptionsEntry>, I>>(
    base?: I,
  ): CameraConfiguration_ConfigOptionsEntry {
    return CameraConfiguration_ConfigOptionsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraConfiguration_ConfigOptionsEntry>, I>>(
    object: I,
  ): CameraConfiguration_ConfigOptionsEntry {
    const message = createBaseCameraConfiguration_ConfigOptionsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ConfigOption.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseCameraConfigurationValueMap(): CameraConfigurationValueMap {
  return { configValues: {} };
}

export const CameraConfigurationValueMap: MessageFns<CameraConfigurationValueMap> = {
  encode(message: CameraConfigurationValueMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.configValues).forEach(([key, value]) => {
      CameraConfigurationValueMap_ConfigValuesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraConfigurationValueMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraConfigurationValueMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = CameraConfigurationValueMap_ConfigValuesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.configValues[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraConfigurationValueMap {
    return {
      configValues: isObject(object.configValues)
        ? Object.entries(object.configValues).reduce<{ [key: string]: ConfigValue }>((acc, [key, value]) => {
          acc[key] = ConfigValue.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: CameraConfigurationValueMap): unknown {
    const obj: any = {};
    if (message.configValues) {
      const entries = Object.entries(message.configValues);
      if (entries.length > 0) {
        obj.configValues = {};
        entries.forEach(([k, v]) => {
          obj.configValues[k] = ConfigValue.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraConfigurationValueMap>, I>>(base?: I): CameraConfigurationValueMap {
    return CameraConfigurationValueMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraConfigurationValueMap>, I>>(object: I): CameraConfigurationValueMap {
    const message = createBaseCameraConfigurationValueMap();
    message.configValues = Object.entries(object.configValues ?? {}).reduce<{ [key: string]: ConfigValue }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = ConfigValue.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseCameraConfigurationValueMap_ConfigValuesEntry(): CameraConfigurationValueMap_ConfigValuesEntry {
  return { key: "", value: undefined };
}

export const CameraConfigurationValueMap_ConfigValuesEntry: MessageFns<CameraConfigurationValueMap_ConfigValuesEntry> =
  {
    encode(
      message: CameraConfigurationValueMap_ConfigValuesEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== undefined) {
        ConfigValue.encode(message.value, writer.uint32(18).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): CameraConfigurationValueMap_ConfigValuesEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCameraConfigurationValueMap_ConfigValuesEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = ConfigValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): CameraConfigurationValueMap_ConfigValuesEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? ConfigValue.fromJSON(object.value) : undefined,
      };
    },

    toJSON(message: CameraConfigurationValueMap_ConfigValuesEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== undefined) {
        obj.value = ConfigValue.toJSON(message.value);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<CameraConfigurationValueMap_ConfigValuesEntry>, I>>(
      base?: I,
    ): CameraConfigurationValueMap_ConfigValuesEntry {
      return CameraConfigurationValueMap_ConfigValuesEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<CameraConfigurationValueMap_ConfigValuesEntry>, I>>(
      object: I,
    ): CameraConfigurationValueMap_ConfigValuesEntry {
      const message = createBaseCameraConfigurationValueMap_ConfigValuesEntry();
      message.key = object.key ?? "";
      message.value = (object.value !== undefined && object.value !== null)
        ? ConfigValue.fromPartial(object.value)
        : undefined;
      return message;
    },
  };

function createBaseCameraFrame(): CameraFrame {
  return { cameraId: "", timestamp: undefined, data: new Uint8Array(0) };
}

export const CameraFrame: MessageFns<CameraFrame> = {
  encode(message: CameraFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cameraId !== "") {
      writer.uint32(10).string(message.cameraId);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(18).fork()).join();
    }
    if (message.data.length !== 0) {
      writer.uint32(26).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cameraId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraFrame {
    return {
      cameraId: isSet(object.cameraId) ? globalThis.String(object.cameraId) : "",
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
    };
  },

  toJSON(message: CameraFrame): unknown {
    const obj: any = {};
    if (message.cameraId !== "") {
      obj.cameraId = message.cameraId;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraFrame>, I>>(base?: I): CameraFrame {
    return CameraFrame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraFrame>, I>>(object: I): CameraFrame {
    const message = createBaseCameraFrame();
    message.cameraId = object.cameraId ?? "";
    message.timestamp = object.timestamp ?? undefined;
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseStereoConfiguration(): StereoConfiguration {
  return { position: 0, linkedCamera: "" };
}

export const StereoConfiguration: MessageFns<StereoConfiguration> = {
  encode(message: StereoConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== 0) {
      writer.uint32(8).int32(message.position);
    }
    if (message.linkedCamera !== "") {
      writer.uint32(18).string(message.linkedCamera);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StereoConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStereoConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.position = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.linkedCamera = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StereoConfiguration {
    return {
      position: isSet(object.position) ? stereoPositionFromJSON(object.position) : 0,
      linkedCamera: isSet(object.linkedCamera) ? globalThis.String(object.linkedCamera) : "",
    };
  },

  toJSON(message: StereoConfiguration): unknown {
    const obj: any = {};
    if (message.position !== 0) {
      obj.position = stereoPositionToJSON(message.position);
    }
    if (message.linkedCamera !== "") {
      obj.linkedCamera = message.linkedCamera;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StereoConfiguration>, I>>(base?: I): StereoConfiguration {
    return StereoConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StereoConfiguration>, I>>(object: I): StereoConfiguration {
    const message = createBaseStereoConfiguration();
    message.position = object.position ?? 0;
    message.linkedCamera = object.linkedCamera ?? "";
    return message;
  },
};

function createBaseStreamInfo(): StreamInfo {
  return { key: "", frameType: 0 };
}

export const StreamInfo: MessageFns<StreamInfo> = {
  encode(message: StreamInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.frameType !== 0) {
      writer.uint32(16).int32(message.frameType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StreamInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreamInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.frameType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StreamInfo {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      frameType: isSet(object.frameType) ? frameTypeFromJSON(object.frameType) : 0,
    };
  },

  toJSON(message: StreamInfo): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.frameType !== 0) {
      obj.frameType = frameTypeToJSON(message.frameType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StreamInfo>, I>>(base?: I): StreamInfo {
    return StreamInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StreamInfo>, I>>(object: I): StreamInfo {
    const message = createBaseStreamInfo();
    message.key = object.key ?? "";
    message.frameType = object.frameType ?? 0;
    return message;
  },
};

function createBaseCameraDevice(): CameraDevice {
  return {
    id: "",
    name: "",
    label: "",
    type: 0,
    modelName: "",
    enabled: false,
    ipAddress: undefined,
    config: undefined,
    status: 0,
    latencyAvg: undefined,
    enableStereo: false,
    stereoConfig: undefined,
    availableStreams: [],
    lastError: undefined,
  };
}

export const CameraDevice: MessageFns<CameraDevice> = {
  encode(message: CameraDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.label !== "") {
      writer.uint32(26).string(message.label);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.modelName !== "") {
      writer.uint32(42).string(message.modelName);
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.ipAddress !== undefined) {
      writer.uint32(58).string(message.ipAddress);
    }
    if (message.config !== undefined) {
      CameraConfiguration.encode(message.config, writer.uint32(66).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(72).int32(message.status);
    }
    if (message.latencyAvg !== undefined) {
      writer.uint32(85).float(message.latencyAvg);
    }
    if (message.enableStereo !== false) {
      writer.uint32(88).bool(message.enableStereo);
    }
    if (message.stereoConfig !== undefined) {
      StereoConfiguration.encode(message.stereoConfig, writer.uint32(98).fork()).join();
    }
    for (const v of message.availableStreams) {
      StreamInfo.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.lastError !== undefined) {
      writer.uint32(114).string(message.lastError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.config = CameraConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.latencyAvg = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.enableStereo = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.stereoConfig = StereoConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.availableStreams.push(StreamInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.lastError = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraDevice {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      type: isSet(object.type) ? cameraTypeFromJSON(object.type) : 0,
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : undefined,
      config: isSet(object.config) ? CameraConfiguration.fromJSON(object.config) : undefined,
      status: isSet(object.status) ? cameraStatusFromJSON(object.status) : 0,
      latencyAvg: isSet(object.latencyAvg) ? globalThis.Number(object.latencyAvg) : undefined,
      enableStereo: isSet(object.enableStereo) ? globalThis.Boolean(object.enableStereo) : false,
      stereoConfig: isSet(object.stereoConfig) ? StereoConfiguration.fromJSON(object.stereoConfig) : undefined,
      availableStreams: globalThis.Array.isArray(object?.availableStreams)
        ? object.availableStreams.map((e: any) => StreamInfo.fromJSON(e))
        : [],
      lastError: isSet(object.lastError) ? globalThis.String(object.lastError) : undefined,
    };
  },

  toJSON(message: CameraDevice): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.type !== 0) {
      obj.type = cameraTypeToJSON(message.type);
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.ipAddress !== undefined) {
      obj.ipAddress = message.ipAddress;
    }
    if (message.config !== undefined) {
      obj.config = CameraConfiguration.toJSON(message.config);
    }
    if (message.status !== 0) {
      obj.status = cameraStatusToJSON(message.status);
    }
    if (message.latencyAvg !== undefined) {
      obj.latencyAvg = message.latencyAvg;
    }
    if (message.enableStereo !== false) {
      obj.enableStereo = message.enableStereo;
    }
    if (message.stereoConfig !== undefined) {
      obj.stereoConfig = StereoConfiguration.toJSON(message.stereoConfig);
    }
    if (message.availableStreams?.length) {
      obj.availableStreams = message.availableStreams.map((e) => StreamInfo.toJSON(e));
    }
    if (message.lastError !== undefined) {
      obj.lastError = message.lastError;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraDevice>, I>>(base?: I): CameraDevice {
    return CameraDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraDevice>, I>>(object: I): CameraDevice {
    const message = createBaseCameraDevice();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.label = object.label ?? "";
    message.type = object.type ?? 0;
    message.modelName = object.modelName ?? "";
    message.enabled = object.enabled ?? false;
    message.ipAddress = object.ipAddress ?? undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? CameraConfiguration.fromPartial(object.config)
      : undefined;
    message.status = object.status ?? 0;
    message.latencyAvg = object.latencyAvg ?? undefined;
    message.enableStereo = object.enableStereo ?? false;
    message.stereoConfig = (object.stereoConfig !== undefined && object.stereoConfig !== null)
      ? StereoConfiguration.fromPartial(object.stereoConfig)
      : undefined;
    message.availableStreams = object.availableStreams?.map((e) => StreamInfo.fromPartial(e)) || [];
    message.lastError = object.lastError ?? undefined;
    return message;
  },
};

function createBaseCameraMetadata(): CameraMetadata {
  return { id: "", metadataJson: "" };
}

export const CameraMetadata: MessageFns<CameraMetadata> = {
  encode(message: CameraMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.metadataJson !== "") {
      writer.uint32(18).string(message.metadataJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadataJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraMetadata {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      metadataJson: isSet(object.metadataJson) ? globalThis.String(object.metadataJson) : "",
    };
  },

  toJSON(message: CameraMetadata): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.metadataJson !== "") {
      obj.metadataJson = message.metadataJson;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraMetadata>, I>>(base?: I): CameraMetadata {
    return CameraMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraMetadata>, I>>(object: I): CameraMetadata {
    const message = createBaseCameraMetadata();
    message.id = object.id ?? "";
    message.metadataJson = object.metadataJson ?? "";
    return message;
  },
};

function createBaseCameraDeviceList(): CameraDeviceList {
  return { cameras: [] };
}

export const CameraDeviceList: MessageFns<CameraDeviceList> = {
  encode(message: CameraDeviceList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cameras) {
      CameraDevice.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraDeviceList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraDeviceList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cameras.push(CameraDevice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraDeviceList {
    return {
      cameras: globalThis.Array.isArray(object?.cameras)
        ? object.cameras.map((e: any) => CameraDevice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CameraDeviceList): unknown {
    const obj: any = {};
    if (message.cameras?.length) {
      obj.cameras = message.cameras.map((e) => CameraDevice.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraDeviceList>, I>>(base?: I): CameraDeviceList {
    return CameraDeviceList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraDeviceList>, I>>(object: I): CameraDeviceList {
    const message = createBaseCameraDeviceList();
    message.cameras = object.cameras?.map((e) => CameraDevice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeviceConfiguration(): DeviceConfiguration {
  return { id: "", name: "", config: undefined, enableStereo: false, stereoConfig: undefined };
}

export const DeviceConfiguration: MessageFns<DeviceConfiguration> = {
  encode(message: DeviceConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.config !== undefined) {
      CameraConfigurationValueMap.encode(message.config, writer.uint32(26).fork()).join();
    }
    if (message.enableStereo !== false) {
      writer.uint32(32).bool(message.enableStereo);
    }
    if (message.stereoConfig !== undefined) {
      StereoConfiguration.encode(message.stereoConfig, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.config = CameraConfigurationValueMap.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enableStereo = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stereoConfig = StereoConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceConfiguration {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      config: isSet(object.config) ? CameraConfigurationValueMap.fromJSON(object.config) : undefined,
      enableStereo: isSet(object.enableStereo) ? globalThis.Boolean(object.enableStereo) : false,
      stereoConfig: isSet(object.stereoConfig) ? StereoConfiguration.fromJSON(object.stereoConfig) : undefined,
    };
  },

  toJSON(message: DeviceConfiguration): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.config !== undefined) {
      obj.config = CameraConfigurationValueMap.toJSON(message.config);
    }
    if (message.enableStereo !== false) {
      obj.enableStereo = message.enableStereo;
    }
    if (message.stereoConfig !== undefined) {
      obj.stereoConfig = StereoConfiguration.toJSON(message.stereoConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceConfiguration>, I>>(base?: I): DeviceConfiguration {
    return DeviceConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceConfiguration>, I>>(object: I): DeviceConfiguration {
    const message = createBaseDeviceConfiguration();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.config = (object.config !== undefined && object.config !== null)
      ? CameraConfigurationValueMap.fromPartial(object.config)
      : undefined;
    message.enableStereo = object.enableStereo ?? false;
    message.stereoConfig = (object.stereoConfig !== undefined && object.stereoConfig !== null)
      ? StereoConfiguration.fromPartial(object.stereoConfig)
      : undefined;
    return message;
  },
};

function createBaseError(): Error {
  return { code: 0, message: "" };
}

export const Error: MessageFns<Error> = {
  encode(message: Error, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).int32(message.code);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Error {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Error {
    return {
      code: isSet(object.code) ? errorCodeFromJSON(object.code) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: Error): unknown {
    const obj: any = {};
    if (message.code !== 0) {
      obj.code = errorCodeToJSON(message.code);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Error>, I>>(base?: I): Error {
    return Error.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = createBaseError();
    message.code = object.code ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseCameraDeviceListResult(): CameraDeviceListResult {
  return { data: undefined, error: undefined };
}

export const CameraDeviceListResult: MessageFns<CameraDeviceListResult> = {
  encode(message: CameraDeviceListResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CameraDeviceList.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraDeviceListResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraDeviceListResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CameraDeviceList.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraDeviceListResult {
    return {
      data: isSet(object.data) ? CameraDeviceList.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CameraDeviceListResult): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CameraDeviceList.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraDeviceListResult>, I>>(base?: I): CameraDeviceListResult {
    return CameraDeviceListResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraDeviceListResult>, I>>(object: I): CameraDeviceListResult {
    const message = createBaseCameraDeviceListResult();
    message.data = (object.data !== undefined && object.data !== null)
      ? CameraDeviceList.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCameraDeviceResult(): CameraDeviceResult {
  return { data: undefined, error: undefined };
}

export const CameraDeviceResult: MessageFns<CameraDeviceResult> = {
  encode(message: CameraDeviceResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CameraDevice.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraDeviceResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraDeviceResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CameraDevice.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraDeviceResult {
    return {
      data: isSet(object.data) ? CameraDevice.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CameraDeviceResult): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CameraDevice.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraDeviceResult>, I>>(base?: I): CameraDeviceResult {
    return CameraDeviceResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraDeviceResult>, I>>(object: I): CameraDeviceResult {
    const message = createBaseCameraDeviceResult();
    message.data = (object.data !== undefined && object.data !== null)
      ? CameraDevice.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCameraMetadataResult(): CameraMetadataResult {
  return { data: undefined, error: undefined };
}

export const CameraMetadataResult: MessageFns<CameraMetadataResult> = {
  encode(message: CameraMetadataResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CameraMetadata.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraMetadataResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraMetadataResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CameraMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraMetadataResult {
    return {
      data: isSet(object.data) ? CameraMetadata.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CameraMetadataResult): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CameraMetadata.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraMetadataResult>, I>>(base?: I): CameraMetadataResult {
    return CameraMetadataResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraMetadataResult>, I>>(object: I): CameraMetadataResult {
    const message = createBaseCameraMetadataResult();
    message.data = (object.data !== undefined && object.data !== null)
      ? CameraMetadata.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCameraFrameResult(): CameraFrameResult {
  return { data: undefined, error: undefined };
}

export const CameraFrameResult: MessageFns<CameraFrameResult> = {
  encode(message: CameraFrameResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CameraFrame.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraFrameResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraFrameResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CameraFrame.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraFrameResult {
    return {
      data: isSet(object.data) ? CameraFrame.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CameraFrameResult): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CameraFrame.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraFrameResult>, I>>(base?: I): CameraFrameResult {
    return CameraFrameResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraFrameResult>, I>>(object: I): CameraFrameResult {
    const message = createBaseCameraFrameResult();
    message.data = (object.data !== undefined && object.data !== null)
      ? CameraFrame.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCameraIntrinsics(): CameraIntrinsics {
  return { width: 0, height: 0, fx: 0, fy: 0, ppx: 0, ppy: 0, distortionCoefficients: [], distortionModel: undefined };
}

export const CameraIntrinsics: MessageFns<CameraIntrinsics> = {
  encode(message: CameraIntrinsics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.width !== 0) {
      writer.uint32(8).int32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(16).int32(message.height);
    }
    if (message.fx !== 0) {
      writer.uint32(29).float(message.fx);
    }
    if (message.fy !== 0) {
      writer.uint32(37).float(message.fy);
    }
    if (message.ppx !== 0) {
      writer.uint32(45).float(message.ppx);
    }
    if (message.ppy !== 0) {
      writer.uint32(53).float(message.ppy);
    }
    writer.uint32(58).fork();
    for (const v of message.distortionCoefficients) {
      writer.float(v);
    }
    writer.join();
    if (message.distortionModel !== undefined) {
      writer.uint32(66).string(message.distortionModel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraIntrinsics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraIntrinsics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.width = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.height = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.fx = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.fy = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.ppx = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.ppy = reader.float();
          continue;
        }
        case 7: {
          if (tag === 61) {
            message.distortionCoefficients.push(reader.float());

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.distortionCoefficients.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.distortionModel = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraIntrinsics {
    return {
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      fx: isSet(object.fx) ? globalThis.Number(object.fx) : 0,
      fy: isSet(object.fy) ? globalThis.Number(object.fy) : 0,
      ppx: isSet(object.ppx) ? globalThis.Number(object.ppx) : 0,
      ppy: isSet(object.ppy) ? globalThis.Number(object.ppy) : 0,
      distortionCoefficients: globalThis.Array.isArray(object?.distortionCoefficients)
        ? object.distortionCoefficients.map((e: any) => globalThis.Number(e))
        : [],
      distortionModel: isSet(object.distortionModel) ? globalThis.String(object.distortionModel) : undefined,
    };
  },

  toJSON(message: CameraIntrinsics): unknown {
    const obj: any = {};
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    if (message.fx !== 0) {
      obj.fx = message.fx;
    }
    if (message.fy !== 0) {
      obj.fy = message.fy;
    }
    if (message.ppx !== 0) {
      obj.ppx = message.ppx;
    }
    if (message.ppy !== 0) {
      obj.ppy = message.ppy;
    }
    if (message.distortionCoefficients?.length) {
      obj.distortionCoefficients = message.distortionCoefficients;
    }
    if (message.distortionModel !== undefined) {
      obj.distortionModel = message.distortionModel;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraIntrinsics>, I>>(base?: I): CameraIntrinsics {
    return CameraIntrinsics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraIntrinsics>, I>>(object: I): CameraIntrinsics {
    const message = createBaseCameraIntrinsics();
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.fx = object.fx ?? 0;
    message.fy = object.fy ?? 0;
    message.ppx = object.ppx ?? 0;
    message.ppy = object.ppy ?? 0;
    message.distortionCoefficients = object.distortionCoefficients?.map((e) => e) || [];
    message.distortionModel = object.distortionModel ?? undefined;
    return message;
  },
};

function createBaseGetCameraIntrinsicsRequest(): GetCameraIntrinsicsRequest {
  return { cameraId: "", frameType: 0 };
}

export const GetCameraIntrinsicsRequest: MessageFns<GetCameraIntrinsicsRequest> = {
  encode(message: GetCameraIntrinsicsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cameraId !== "") {
      writer.uint32(10).string(message.cameraId);
    }
    if (message.frameType !== 0) {
      writer.uint32(16).int32(message.frameType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCameraIntrinsicsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCameraIntrinsicsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cameraId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.frameType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCameraIntrinsicsRequest {
    return {
      cameraId: isSet(object.cameraId) ? globalThis.String(object.cameraId) : "",
      frameType: isSet(object.frameType) ? frameTypeFromJSON(object.frameType) : 0,
    };
  },

  toJSON(message: GetCameraIntrinsicsRequest): unknown {
    const obj: any = {};
    if (message.cameraId !== "") {
      obj.cameraId = message.cameraId;
    }
    if (message.frameType !== 0) {
      obj.frameType = frameTypeToJSON(message.frameType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCameraIntrinsicsRequest>, I>>(base?: I): GetCameraIntrinsicsRequest {
    return GetCameraIntrinsicsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCameraIntrinsicsRequest>, I>>(object: I): GetCameraIntrinsicsRequest {
    const message = createBaseGetCameraIntrinsicsRequest();
    message.cameraId = object.cameraId ?? "";
    message.frameType = object.frameType ?? 0;
    return message;
  },
};

function createBaseCameraIntrinsicsResult(): CameraIntrinsicsResult {
  return { data: undefined, error: undefined };
}

export const CameraIntrinsicsResult: MessageFns<CameraIntrinsicsResult> = {
  encode(message: CameraIntrinsicsResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CameraIntrinsics.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CameraIntrinsicsResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCameraIntrinsicsResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CameraIntrinsics.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CameraIntrinsicsResult {
    return {
      data: isSet(object.data) ? CameraIntrinsics.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: CameraIntrinsicsResult): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CameraIntrinsics.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CameraIntrinsicsResult>, I>>(base?: I): CameraIntrinsicsResult {
    return CameraIntrinsicsResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CameraIntrinsicsResult>, I>>(object: I): CameraIntrinsicsResult {
    const message = createBaseCameraIntrinsicsResult();
    message.data = (object.data !== undefined && object.data !== null)
      ? CameraIntrinsics.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

/** @language: cpp, python */
export interface CameraBotService {
  GetDiscoveredDevices(request: Empty): Promise<CameraDeviceListResult>;
  SetDeviceEnabled(request: CameraDevice): Promise<CameraDeviceResult>;
  ConfigureDevice(request: DeviceConfiguration): Promise<CameraDeviceResult>;
  GetDeviceMetadata(request: CameraId): Promise<CameraMetadataResult>;
  GetDevice(request: CameraId): Promise<CameraDeviceResult>;
  GetFrame(request: GetFrameRequest): Promise<CameraFrameResult>;
  GetCameraIntrinsics(request: GetCameraIntrinsicsRequest): Promise<CameraIntrinsicsResult>;
}

export const CameraBotServiceServiceName = "camerabot.CameraBotService";
export class CameraBotServiceClientImpl implements CameraBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || CameraBotServiceServiceName;
    this.rpc = rpc;
    this.GetDiscoveredDevices = this.GetDiscoveredDevices.bind(this);
    this.SetDeviceEnabled = this.SetDeviceEnabled.bind(this);
    this.ConfigureDevice = this.ConfigureDevice.bind(this);
    this.GetDeviceMetadata = this.GetDeviceMetadata.bind(this);
    this.GetDevice = this.GetDevice.bind(this);
    this.GetFrame = this.GetFrame.bind(this);
    this.GetCameraIntrinsics = this.GetCameraIntrinsics.bind(this);
  }
  GetDiscoveredDevices(request: Empty): Promise<CameraDeviceListResult> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDiscoveredDevices", data);
    return promise.then((data) => CameraDeviceListResult.decode(new BinaryReader(data)));
  }

  SetDeviceEnabled(request: CameraDevice): Promise<CameraDeviceResult> {
    const data = CameraDevice.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetDeviceEnabled", data);
    return promise.then((data) => CameraDeviceResult.decode(new BinaryReader(data)));
  }

  ConfigureDevice(request: DeviceConfiguration): Promise<CameraDeviceResult> {
    const data = DeviceConfiguration.encode(request).finish();
    const promise = this.rpc.request(this.service, "ConfigureDevice", data);
    return promise.then((data) => CameraDeviceResult.decode(new BinaryReader(data)));
  }

  GetDeviceMetadata(request: CameraId): Promise<CameraMetadataResult> {
    const data = CameraId.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDeviceMetadata", data);
    return promise.then((data) => CameraMetadataResult.decode(new BinaryReader(data)));
  }

  GetDevice(request: CameraId): Promise<CameraDeviceResult> {
    const data = CameraId.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDevice", data);
    return promise.then((data) => CameraDeviceResult.decode(new BinaryReader(data)));
  }

  GetFrame(request: GetFrameRequest): Promise<CameraFrameResult> {
    const data = GetFrameRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetFrame", data);
    return promise.then((data) => CameraFrameResult.decode(new BinaryReader(data)));
  }

  GetCameraIntrinsics(request: GetCameraIntrinsicsRequest): Promise<CameraIntrinsicsResult> {
    const data = GetCameraIntrinsicsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetCameraIntrinsics", data);
    return promise.then((data) => CameraIntrinsicsResult.decode(new BinaryReader(data)));
  }
}

/** @language: cpp, python */
export interface CameraBotTopics {
  CameraStream(request: CameraFrame): Promise<Nothing>;
}

export const CameraBotTopicsServiceName = "camerabot.CameraBotTopics";
export class CameraBotTopicsClientImpl implements CameraBotTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || CameraBotTopicsServiceName;
    this.rpc = rpc;
    this.CameraStream = this.CameraStream.bind(this);
  }
  CameraStream(request: CameraFrame): Promise<Nothing> {
    const data = CameraFrame.encode(request).finish();
    const promise = this.rpc.request(this.service, "CameraStream", data);
    return promise.then((data) => Nothing.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/camera_bot_service.proto",
    "package": "camerabot",
    "dependency": ["google/protobuf/timestamp.proto", "google/protobuf/empty.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "Nothing",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraId",
      "field": [{
        "name": "value",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "value",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetFrameRequest",
      "field": [{
        "name": "camera_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "stream_name",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "streamName",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_stream_name", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraTrack",
      "field": [{
        "name": "name",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "name",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "frame_type",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.FrameType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "frameType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "camera_id",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraId",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ConfigValue",
      "field": [{
        "name": "int_value",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intValue",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "float_value",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "floatValue",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "string_value",
        "number": 4,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stringValue",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "bool_value",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "boolValue",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "value", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ConfigOption",
      "field": [{
        "name": "display_name",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "displayName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "description",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "description",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "can_edit",
        "number": 3,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "canEdit",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "config_value",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.ConfigValue",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "configValue",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "type",
        "number": 5,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.ConfigValueType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "type",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "requires_restart",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "requiresRestart",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "priority",
        "number": 7,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "priority",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "min_value",
        "number": 8,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "minValue",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "max_value",
        "number": 9,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "maxValue",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_priority", "options": undefined }, { "name": "_min_value", "options": undefined }, {
        "name": "_max_value",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraConfiguration",
      "field": [{
        "name": "config_options",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".camerabot.CameraConfiguration.ConfigOptionsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "configOptions",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [{
        "name": "ConfigOptionsEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 11,
          "typeName": ".camerabot.ConfigOption",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraConfigurationValueMap",
      "field": [{
        "name": "config_values",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".camerabot.CameraConfigurationValueMap.ConfigValuesEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "configValues",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [{
        "name": "ConfigValuesEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 11,
          "typeName": ".camerabot.ConfigValue",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraFrame",
      "field": [{
        "name": "camera_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestamp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "data",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StereoConfiguration",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.StereoPosition",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "linked_camera",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linkedCamera",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StreamInfo",
      "field": [{
        "name": "key",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "key",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "frame_type",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.FrameType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "frameType",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraDevice",
      "field": [{
        "name": "id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "id",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "name",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "name",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "label",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "label",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "type",
        "number": 4,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.CameraType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "type",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_name",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "enabled",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "enabled",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ip_address",
        "number": 7,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ipAddress",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "config",
        "number": 8,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraConfiguration",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "config",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "status",
        "number": 9,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.CameraStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "status",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_avg",
        "number": 10,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "latencyAvg",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "enable_stereo",
        "number": 11,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "enableStereo",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "stereo_config",
        "number": 12,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.StereoConfiguration",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "stereoConfig",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "available_streams",
        "number": 13,
        "label": 3,
        "type": 11,
        "typeName": ".camerabot.StreamInfo",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "availableStreams",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "last_error",
        "number": 14,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "lastError",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_ip_address", "options": undefined }, { "name": "_latency_avg", "options": undefined }, {
        "name": "_stereo_config",
        "options": undefined,
      }, { "name": "_last_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraMetadata",
      "field": [{
        "name": "id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "id",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "metadata_json",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "metadataJson",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraDeviceList",
      "field": [{
        "name": "cameras",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".camerabot.CameraDevice",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameras",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DeviceConfiguration",
      "field": [{
        "name": "id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "id",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "name",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "name",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "config",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraConfigurationValueMap",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "config",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "enable_stereo",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "enableStereo",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "stereo_config",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.StereoConfiguration",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stereoConfig",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_stereo_config", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Error",
      "field": [{
        "name": "code",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.ErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "code",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraDeviceListResult",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraDeviceList",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraDeviceResult",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraDevice",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraMetadataResult",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraMetadata",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraFrameResult",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraIntrinsics",
      "field": [{
        "name": "width",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "width",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "height",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "height",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "fx",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "fy",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ppx",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ppx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ppy",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ppy",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "distortion_coefficients",
        "number": 7,
        "label": 3,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "distortionCoefficients",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "distortion_model",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "distortionModel",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_distortion_model", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetCameraIntrinsicsRequest",
      "field": [{
        "name": "camera_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cameraId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "frame_type",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".camerabot.FrameType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "frameType",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraIntrinsicsResult",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.CameraIntrinsics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".camerabot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "FrameType",
      "value": [
        { "name": "UNKNOWN", "number": 0, "options": undefined },
        { "name": "COLOR", "number": 1, "options": undefined },
        { "name": "DEPTH", "number": 2, "options": undefined },
        { "name": "STEREO", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraType",
      "value": [
        { "name": "UNKNOWN_CAMERA", "number": 0, "options": undefined },
        { "name": "REALSENSE", "number": 1, "options": undefined },
        { "name": "LUXONIS", "number": 2, "options": undefined },
        { "name": "STATIC_VIDEO", "number": 3, "options": undefined },
        { "name": "GIGE", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ConnectionType",
      "value": [{ "name": "UNKNOWN_CONNECTION", "number": 0, "options": undefined }, {
        "name": "ETHERNET",
        "number": 1,
        "options": undefined,
      }, { "name": "USB", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CameraStatus",
      "value": [
        { "name": "DISCONNECTED", "number": 0, "options": undefined },
        { "name": "BUSY", "number": 1, "options": undefined },
        { "name": "CONNECTING", "number": 2, "options": undefined },
        { "name": "CONNECTED", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ErrorCode",
      "value": [{ "name": "UNKNOWN_ERROR", "number": 0, "options": undefined }, {
        "name": "NOT_FOUND",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ConfigValueType",
      "value": [
        { "name": "UNKNOWN_VALUE", "number": 0, "options": undefined },
        { "name": "INT_VALUE", "number": 1, "options": undefined },
        { "name": "FLOAT_VALUE", "number": 2, "options": undefined },
        { "name": "STRING_VALUE", "number": 3, "options": undefined },
        { "name": "BOOL_VALUE", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StereoPosition",
      "value": [{ "name": "LEFT", "number": 0, "options": undefined }, {
        "name": "RIGHT",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "CameraBotService",
      "method": [{
        "name": "GetDiscoveredDevices",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".camerabot.CameraDeviceListResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetDeviceEnabled",
        "inputType": ".camerabot.CameraDevice",
        "outputType": ".camerabot.CameraDeviceResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ConfigureDevice",
        "inputType": ".camerabot.DeviceConfiguration",
        "outputType": ".camerabot.CameraDeviceResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetDeviceMetadata",
        "inputType": ".camerabot.CameraId",
        "outputType": ".camerabot.CameraMetadataResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetDevice",
        "inputType": ".camerabot.CameraId",
        "outputType": ".camerabot.CameraDeviceResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetFrame",
        "inputType": ".camerabot.GetFrameRequest",
        "outputType": ".camerabot.CameraFrameResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetCameraIntrinsics",
        "inputType": ".camerabot.GetCameraIntrinsicsRequest",
        "outputType": ".camerabot.CameraIntrinsicsResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "CameraBotTopics",
      "method": [{
        "name": "CameraStream",
        "inputType": ".camerabot.CameraFrame",
        "outputType": ".camerabot.Nothing",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/can/protos/messenger",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [6, 0],
        "span": [8, 0, 16, 1],
        "leadingComments": " @language: cpp, python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1],
        "span": [19, 0, 21, 1],
        "leadingComments": " @language: cpp, python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4],
        "span": [69, 0, 72, 1],
        "leadingComments": " TODO Refine these\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [84, 0, 94, 1],
        "leadingComments": " Represents a single configuration option\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [105, 0, 107, 1],
        "leadingComments": " A complete camera configuration composed of many config options\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 13],
        "span": [148, 2, 34],
        "leadingComments": "",
        "trailingComments": " Most recent error message from camera\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 15],
        "span": [169, 0, 172, 1],
        "leadingComments": " Error information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".camerabot.FrameType": FrameType,
    ".camerabot.CameraType": CameraType,
    ".camerabot.ConnectionType": ConnectionType,
    ".camerabot.CameraStatus": CameraStatus,
    ".camerabot.ErrorCode": ErrorCode,
    ".camerabot.ConfigValueType": ConfigValueType,
    ".camerabot.StereoPosition": StereoPosition,
    ".camerabot.Nothing": Nothing,
    ".camerabot.CameraId": CameraId,
    ".camerabot.GetFrameRequest": GetFrameRequest,
    ".camerabot.CameraTrack": CameraTrack,
    ".camerabot.ConfigValue": ConfigValue,
    ".camerabot.ConfigOption": ConfigOption,
    ".camerabot.CameraConfiguration": CameraConfiguration,
    ".camerabot.CameraConfiguration.ConfigOptionsEntry": CameraConfiguration_ConfigOptionsEntry,
    ".camerabot.CameraConfigurationValueMap": CameraConfigurationValueMap,
    ".camerabot.CameraConfigurationValueMap.ConfigValuesEntry": CameraConfigurationValueMap_ConfigValuesEntry,
    ".camerabot.CameraFrame": CameraFrame,
    ".camerabot.StereoConfiguration": StereoConfiguration,
    ".camerabot.StreamInfo": StreamInfo,
    ".camerabot.CameraDevice": CameraDevice,
    ".camerabot.CameraMetadata": CameraMetadata,
    ".camerabot.CameraDeviceList": CameraDeviceList,
    ".camerabot.DeviceConfiguration": DeviceConfiguration,
    ".camerabot.Error": Error,
    ".camerabot.CameraDeviceListResult": CameraDeviceListResult,
    ".camerabot.CameraDeviceResult": CameraDeviceResult,
    ".camerabot.CameraMetadataResult": CameraMetadataResult,
    ".camerabot.CameraFrameResult": CameraFrameResult,
    ".camerabot.CameraIntrinsics": CameraIntrinsics,
    ".camerabot.GetCameraIntrinsicsRequest": GetCameraIntrinsicsRequest,
    ".camerabot.CameraIntrinsicsResult": CameraIntrinsicsResult,
    ".camerabot.CameraBotService": CameraBotServiceClientImpl,
    ".camerabot.CameraBotTopics": CameraBotTopicsClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2],
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
